import { GET_USER_BUSINESS_ID } from "../../../browser-db-config/localStorage";
import { HTTP_REQUEST } from "../../../http-config/trac-http-req";


const state = {
  // walletDetails: null,
};

const getters = {
  // GET_WALLET_DETAILS: (state) => state.walletDetails,
};

const actions = {

  FETCH_SETTLEMENT_TYPE: async function (context) {
    const httpReq = {
      url: `/v2/settlements/business/${GET_USER_BUSINESS_ID()}/preferences`,
      method: "GET",
      authRequest: true,
    };

    // Fetch online
    const httpRes = await HTTP_REQUEST(httpReq);

    return httpRes;
    // return Promise.resolve({
    //   code: 200,
    //   data: [
    //     {
    //       id: 1,
    //       created_at: '2023-11-06T15:28:50.431Z',
    //       updated_at: '2023-11-06T15:28:52.277Z',
    //       deleted_at: '0001-01-01T00:00:00Z',
    //       name: 'instant',
    //       selected: true, // is this the current preference?
    //       title: 'Instant Merchant Settlement', // title needed for frontend
    //       description: 'instant merchant settlement', // longer description. Favour will provide
    //       label: 'instant',
    //       subOptions: [],
    //       icon: 'https://s3-us-west-1.amazonaws.com/tractionapp-products/pkg/app/uploads/5383391591335942212instant-settlement-icon.png'
    //     },
    //     {
    //       id: 2,
    //       created_at: '2023-11-06T15:28:50.431Z',
    //       updated_at: '2023-11-06T15:28:52.277Z',
    //       deleted_at: '0001-01-01T00:00:00Z',
    //       name: 'sameday',
    //       subOptions: [
    //         {
    //           id: 1,
    //           created_at: '2023-11-06T15:28:50.431Z',
    //           updated_at: '2023-11-06T15:28:52.277Z',
    //           deleted_at: '0001-01-01T00:00:00Z',
    //           name: 'multistore',
    //           selected: false,
    //           title: 'Multi Store Settlement',
    //           description: 'Multi Store settlement',
    //           label: 'instant',
    //           icon: 'https://s3-us-west-1.amazonaws.com/tractionapp-products/pkg/app/uploads/5383391591335942212instant-settlement-icon.png'
    //         },
    //         {
    //           id: 2,
    //           created_at: '2023-11-06T15:28:50.431Z',
    //           updated_at: '2023-11-06T15:28:52.277Z',
    //           deleted_at: '0001-01-01T00:00:00Z',
    //           name: 'business',
    //           selected: false,
    //           title: 'Business Settlement',
    //           description: 'business merchant settlement',
    //           label: 'business',
    //           icon: 'https://s3-us-west-1.amazonaws.com/tractionapp-products/pkg/app/uploads/5383391591335942212business-settlement-icon.png'
    //         }
    //       ],
    //       selected: false, // if any of the subOptions is selected, this becomes true
    //       title: 'Sameday Settlement',
    //       description: 'sameday merchant settlement',
    //       label: 'sameday',
    //       icon: 'https://s3-us-west-1.amazonaws.com/tractionapp-products/pkg/app/uploads/5383391591335942212sameday-settlement-icon.png'
    //     }
    //   ],
    //   status: true
    // })
  },
  UPDATE_SETTLEMENT_TYPE: async function (context, payload) {
    const httpReq = {
      url: `/v1/businesses/settlement/updatetype/${GET_USER_BUSINESS_ID()}`,
      method: "POST",
      authRequest: true,
      body: payload,
    };

    // Fetch online
    const httpRes = await HTTP_REQUEST(httpReq);

    if (httpRes.status) {
      // context.commit("SETUP_WALLET_DETAILS", httpRes);
    }

    return httpRes;
  },
  // FETCH_WALLET_DETAILS: async function (context) {
  //   // Always fetching stores
  //   const httpReq = {
  //     url: `/api/EWTraction/accountdetailsbyuserguid/${GET_USER_BUSINESS_ID()}`,
  //     method: "GET",
  //     authRequest: true,
  //   };

  //   // Fetch online
  //   const httpRes = await HTTP_REQUEST(httpReq);

  //   if (httpRes.status) {
  //     context.commit("SETUP_WALLET_DETAILS", httpRes);
  //   }
  // },
  // FETCH_TELCOMS: async function (context) {
  //   // Always fetching stores
  //   const httpReq = {
  //     url: `/api/EWTraction/telcoms`,
  //     method: "GET",
  //     authRequest: true,
  //   };

  //   // Fetch online
  //   const httpRes = await HTTP_REQUEST(httpReq);

  //   if (httpRes.status) {
  //   }
  //   return httpRes;
  // },
  // FETCH_TELCOMS_DATA_INFO: async function (context, payload) {
  //   // Always fetching stores
  //   const httpReq = {
  //     // url: `/api/EWTraction/telcoms`,
  //     url: `/api/EWTraction/mobiledata/${payload.selectedNetwork}`,
  //     method: "GET",
  //     authRequest: true,
  //   };

  //   // Fetch online
  //   const httpRes = await HTTP_REQUEST(httpReq);

  //   if (httpRes.status) {
  //   }
  //   return httpRes;
  // },
  // TRANSFER_TO_BENEFICIARY: async function (context, payload) {
  //   console.log(payload);
  //   // Always fetching stores
  //   const httpReq = {
  //     url: `/api/EWTraction/transferFunds/${payload.wallet.walletid}`,
  //     method: "POST",
  //     authRequest: true,
  //     body: payload.transferDetails,
  //   };

  //   // Fetch online
  //   const httpRes = await HTTP_REQUEST(httpReq);

  //   if (httpRes.status) {

  //   }

  //   return httpRes;
  // },
  // MAKE_AIRTIME_REQUEST: async function (context, payload) {
  //   console.log(payload);
  //   // Always fetching stores
  //   const httpReq = {
  //     url: `/api/EWTraction/product/airtime/${payload.walletDetails.walletid}`,
  //     method: "POST",
  //     authRequest: true,
  //     body: payload,
  //   };

  //   // Fetch online
  //   const httpRes = await HTTP_REQUEST(httpReq);

  //   if (httpRes.status) {

  //   }

  //   return httpRes;
  // },
  // MAKE_DATA_REQUEST: async function (context, payload) {
  //   console.log(payload);
  //   // Always fetching stores
  //   const httpReq = {
  //     url: `/api/EWTraction/product/mobiledata/${virtualNumber}`,
  //     method: "POST",
  //     authRequest: true,
  //     body: payload,
  //   };

  //   // Fetch online
  //   const httpRes = await HTTP_REQUEST(httpReq);

  //   if (httpRes.status) {

  //   }

  //   return httpRes;
  // },
};

const mutations = {
  // SETUP_WALLET_DETAILS: (state, data) => {
  //   state.walletDetails = data;
  // },
  // SETUP_ALL_BENFICIARIES_BANKS: (state, data) => {
  //   state.allBanks = data;
  // },
  // UPDATE_ALL_BENEFICIARIES: (state, data) => {
  //   state.allBeneficiaries.data.push(data);
  // },
  // UPDATE_DELETED_BENEFICIARIES: (state, data) => {
  //   state.allBeneficiaries.data = state.allBeneficiaries.data.filter(beneficiary => beneficiary.beneficiaryGuid !== data.benficiaryID);
  // }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
